import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output} from '@angular/core';

require('./bringoz-toggle.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-toggle',
  templateUrl: './bringoz-toggle.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class BringozToggleComponent {
  @Input() checked: boolean;
  @Input() theme: 'primary' | 'secondary' = 'primary';
  @Input() label: string = '';
  @Input() name: string = '';

  @Output() onToggle = new EventEmitter<boolean>();
  constructor(@Inject('$timeout') private $timeout) {
  }

  onChange(event: Event): void {
    this.onToggle.emit(!this.checked);
    this.$timeout(0).then(() => {});
  }
}
